import React, { useContext } from "react";
import DOMPurify from "dompurify";
import GeneralContext from "../../context/GeneralContext"
import styles from "./MensajeError.module.css";
import * as GeneralActions from "../../store/actions/generalActions";
import AuthService from '../../utils/auth/Auth.service';

const MensajeError = () => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    const authService = new AuthService()

    const cerrarSesion = async () => {
        generalDispatch(GeneralActions.logout())
        authService.logout()
    }

    const aceptar = async () => {
        if(generalState.error.accion !== undefined) {
            await generalState.error.accion()
        }
    }

    const cancelar = async () => {
        if(generalState.error.codigoRespuesta === 401) {
            await cerrarSesion()
        } else {
            if(generalState.error.cancelar !== undefined) {
                await generalState.error.cancelar()
            }
        }
        generalDispatch(GeneralActions.updateError(null))
    }

    return (
        <React.Fragment>
            {generalState.error !== null
                ? <div className={`${styles['w3-modal']} ${styles['show']}`}>
                    <div className={styles['w3-modal-content']}>
                        <div className={styles['w3-header']}>
                        </div>
                        <div className={styles['w3-container']}>
                            <p className={styles['w3title']}>
                                {generalState.error.titulo}
                            </p>
                            <div className={`${styles['grupo-de-form']} ${styles['top-18']}`}>
                                <div className={styles['area-50']}>
                                    <label align={"justify"} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(generalState.error.mensajeRespuesta) }}/>
                                </div>
                            </div>    
                            {generalState.error.accion !== undefined
                                ? <div className={styles['w3areabtn']}>
                                    <button className={`${styles['btn-pago-accion']}`} onClick = {() => aceptar()} >
                                        {generalState.error.labelAccion}
                                    </button>
                                    <button className={`${styles['btn-cancelar']} ${styles['w3-margen']}`} onClick = {() => cancelar()}>
                                        Cancelar
                                    </button>
                                </div>
                                : <div className={styles['w3areabtn']}>
                                    <button style={{width: '60%'}} className={`${styles['btn-pago-accion']}`}
                                        onClick = {() => cancelar()}>
                                            {generalState.error.codigoRespuesta === 401 ? 'Salir' : 'Aceptar'}
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                : null
            }
        </React.Fragment>
    )
}

export default MensajeError;